import { useState } from 'react';
import './App.css';
import CaribbeanMap from './components/CaribbeanMap';
import DayNav from './components/DayNav';
import { useBiteLog } from './hooks/useBiteLog';
import { useIpGeo } from './hooks/useIpGeo';
import { toDateKey } from './utils/dateUtils';

function App() {
  const [dateKey, setDateKey] = useState(() => toDateKey(new Date()));
  const { bites, addBite, removeBite, daysWithBites } = useBiteLog(dateKey);
  const { geo: ipGeo } = useIpGeo();

  return (
    <div className="app">
      <header className="app-header">
        <div className="header-title">
          <span className="logo-icon">🦟</span>
          <h1>Ti-Yenyen</h1>
          <span className="subtitle">Carte des piqûres – Caraïbes</span>
        </div>
        <div className="header-count">
          {bites.length > 0 && (
            <span className="bite-badge">
              {bites.length} piqûre{bites.length > 1 ? 's' : ''} ce jour
            </span>
          )}
        </div>
      </header>

      <DayNav
        dateKey={dateKey}
        setDateKey={setDateKey}
        daysWithBites={daysWithBites}
      />

      <main className="map-container">
        <CaribbeanMap
          bites={bites}
          addBite={addBite}
          removeBite={removeBite}
          ipGeo={ipGeo}
        />
      </main>
    </div>
  );
}

export default App;
